"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usingGateway = void 0;
var gatewayCaller_1 = __importDefault(require("@atg/icf-platform/lib/client/gatewayCaller"));
// create a wrapper for mocking purposes
var usingGateway = function (guid) { return (0, gatewayCaller_1.default)(guid); };
exports.usingGateway = usingGateway;
//# sourceMappingURL=GatewayService.js.map